const blocks = document.querySelectorAll(
  ".wp-block-adspire-ai-feature-timeline"
);

if (blocks.length) {
  import("./view-frontend").then(({ initBlock }) => {
    blocks.forEach((block) => initBlock(block));
  });
}
